import React, { useState, useCallback, createContext, useContext } from 'react';

type ToastType = 'success' | 'error' | 'warning';

export interface ToastItem {
    id: string;
    type: ToastType;
    title?: string;
    message: string;
    duration?: number;
}

interface ToastContextType {
    toasts: ToastItem[];
    showToast: (message: string, type: ToastType, title?: string, duration?: number) => void;
    closeToast: (id: string) => void;
}

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastContextProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [toasts, setToasts] = useState<ToastItem[]>([]);

    const showToast = useCallback((message: string, type: ToastType, title?: string, duration?: number) => {
        const id = Date.now().toString() + Math.random().toString(36).substring(2, 9);
        const newToast: ToastItem = { id, type, title, message, duration };

        setToasts((prevToasts) => [...prevToasts, newToast]);
    }, []);

    const closeToast = useCallback((id: string) => {
        setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
    }, []);

    const value = { toasts, showToast, closeToast };

    return (
        <ToastContext.Provider value={value}>
            {children}
        </ToastContext.Provider>
    );
};

export const useToastContext = () => {
    const context = useContext(ToastContext);
    if (context === undefined) {
        throw new Error('useToastContext, bir ToastContextProvider içinde kullanılmalıdır.');
    }
    return context;
};